<template>
  <transition name="fade">
    <div>
        <router-view></router-view>
    </div>
  </transition>
</template>

<script>
import router from './router'
import Store from './store'
import { interceptors, revoke } from './helpers/api'

export default {
  name: 'App',
  data () {
    return {
      section: 'Head'
    }
  },

  computed: {

  },

  methods: {
    
  },

 created() {
    // global error http handler
			interceptors((err) => {
				if(err.response.status === 401) {
          //Auth.remove()
          revoke()
					this.$router.push({ name: 'login'})
				}

				if(err.response.status === 500) {
					//Flash.setError(err.response.statusText)
				}

				if(err.response.status === 404) {
					this.$router.push({ name: '404'})
				}
			})
 }
}
</script>

<style>
  html { overflow-y: auto }

</style>

